import _extends from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React from 'react';
import styled from 'styled-components';
// import slugify from 'url-slug';
import urlSlug from 'url-slug';
import styles from './ThreeTile.style';
import { withTheme } from 'styled-components';
import Carousel from '../../molecules/Carousel';
import Heading from '../../atoms/Heading';
import Anchor from '../../atoms/Anchor';
import Para from '../../atoms/Para';
import ImageTextCard from '../../molecules/ImageTextCard';
import constants, { siteConstants } from '../../../constants/globalConstants';
import RichText from '../../atoms/RichText/RichText';
import { filterPromoData } from '../../../utils/utilityFunction';
import { imageRenditions } from './config';
import CarouselArrow from '../../atoms/CarouselArrow';
import { ContentfulLivePreview } from '@contentful/live-preview';
import Mailchimp from '../../atoms/Mailchimp';
var ThreeTileBlock = styled.section.withConfig({
  componentId: "sc-ckwi5v-0"
})(["", ";"], styles);
var ThreeTile = function ThreeTile(_ref) {
  var _threeTileData$sys, _threeTileData$sys2, _threeTileData$sys3, _threeTileData$cta$sy, _threeTileData$ctaMul, _threeTileData$ctaMul2, _threeTileData$ctaMul3;
  var threeTileData = _ref.threeTileData,
    className = _ref.className,
    theme = _ref.theme;
  /**
   * Promotion data is filtered  based on promotionStart & promotionEnd
   * updated the filter function to iterate over elem's keys if it exists, and check if each value is null
   * this is due to the shape of the contentful graphql response. otheriwse, if already null, return false
   */

  var threeTileDataList = threeTileData.tile && threeTileData.tile.map(function (item) {
    return filterPromoData(item);
  }).filter(function (elem) {
    return elem !== null;
  }) || threeTileData.tileCollection && threeTileData.tileCollection.items.map(function (item) {
    return filterPromoData(item);
  }).filter(function (elem) {
    return elem && !Object.values(elem).every(function (value) {
      return value === null;
    });
  });
  var Settings = {
    slidesToScroll: 1,
    slidesToShow: 1,
    cssEase: 'linear',
    arrows: true,
    speed: 500,
    dots: true,
    prevArrow: __jsx(CarouselArrow, {
      type: "previous"
    }),
    nextArrow: __jsx(CarouselArrow, {
      type: "next"
    })
  };
  var variation = threeTileData.variation ? threeTileData.variation.toLowerCase() : '';
  var topAnchorclassName = "".concat(variation, "-link");
  var tileAnchorclassName = "nva-3-tile__card-link tile-link secondary ".concat(variation, "-link");
  var idVal = threeTileData.anchorLink ? urlSlug(threeTileData.anchorLink) : '';
  var richTextEmbeddedAsset = threeTileData.bodyText && threeTileData.bodyText.links && threeTileData.bodyText.links.assets.block || [];
  var topPadding = threeTileData.topPadding,
    bottomPadding = threeTileData.bottomPadding;
  var wrapperClassName = "col-xs-12 tile-wrapper";
  // top padding from contentful
  wrapperClassName += topPadding === null || topPadding === 'Default' || topPadding === undefined ? '' : " padding-top-override-".concat(topPadding.toLowerCase());
  // bottom padding from contentful
  wrapperClassName += bottomPadding === null || bottomPadding === 'Default' || bottomPadding === undefined ? '' : " padding-bottom-override-".concat(bottomPadding.toLowerCase());
  var attributes = {};
  if (idVal != '') attributes.id = idVal;
  if (className) attributes.className = "nva-3-tile nva-3-tile--".concat(variation, " ").concat(className);
  return __jsx("div", _extends({}, attributes, {
    "data-entry-id": (_threeTileData$sys = threeTileData.sys) === null || _threeTileData$sys === void 0 ? void 0 : _threeTileData$sys.id
  }), threeTileData && __jsx("div", {
    className: "nva-3-tile__container container"
  }, __jsx(ThreeTileBlock, {
    className: "nva-3-tile__wrapper ".concat(wrapperClassName)
  }, (threeTileData === null || threeTileData === void 0 ? void 0 : threeTileData.categoryTitle) && __jsx(Para, {
    className: "nva-3-tile__category-title u-overline col-xs-10"
  }, threeTileData === null || threeTileData === void 0 ? void 0 : threeTileData.categoryTitle), (threeTileData === null || threeTileData === void 0 ? void 0 : threeTileData.sectionHeadline) && __jsx(Heading, {
    HeadingType: "h2",
    className: "nva-3-tile__heading three-tile-top-heading col-xs-10",
    contentfulLivePreview: ContentfulLivePreview.getProps({
      entryId: threeTileData === null || threeTileData === void 0 ? void 0 : (_threeTileData$sys2 = threeTileData.sys) === null || _threeTileData$sys2 === void 0 ? void 0 : _threeTileData$sys2.id,
      fieldId: "sectionHeadline"
    })
  }, threeTileData === null || threeTileData === void 0 ? void 0 : threeTileData.sectionHeadline), threeTileData.bodyText && __jsx(RichText, {
    className: "col-xs-10 col-sm-8 col-md-10 nva-3-tile__description three-tile-top-description",
    jsonContent: threeTileData.bodyText && threeTileData.bodyText.bodyText || threeTileData.bodyText && threeTileData.bodyText.json,
    richTextEmbeddedAsset: richTextEmbeddedAsset,
    contentfulLivePreview: ContentfulLivePreview.getProps({
      entryId: threeTileData === null || threeTileData === void 0 ? void 0 : (_threeTileData$sys3 = threeTileData.sys) === null || _threeTileData$sys3 === void 0 ? void 0 : _threeTileData$sys3.id,
      fieldId: "bodyText"
    })
  }), threeTileData.cta && threeTileData.cta.url && threeTileData.cta.behavior && threeTileData.cta.label && __jsx(Para, {
    className: "nva-3-tile__link-wrapper ".concat(topAnchorclassName)
  }, __jsx(Anchor, {
    "data-entry-id": (_threeTileData$cta$sy = threeTileData.cta.sys) === null || _threeTileData$cta$sy === void 0 ? void 0 : _threeTileData$cta$sy.id,
    title: threeTileData.cta.label,
    to: threeTileData.cta.url,
    ctaBehavior: threeTileData.cta.behavior,
    hyperlinkType: threeTileData.cta.hyperlinkType,
    className: "nva-3-tile__anchor arrow secondary three-tile-top-cta",
    "aria-label": threeTileData.cta.ariaLabel,
    styleType: variation === constants.variations.variationB.toLowerCase() ? 'primary-anchor' : '',
    type: threeTileData.cta.type,
    ninetailedEvent: threeTileData.cta.ninetailedEvent,
    ninetailedTraits: threeTileData.cta.ninetailedTraits,
    "data-analytics-type": constants.analytics.analyticsType.sectionCTA,
    "data-analytics-value": threeTileData === null || threeTileData === void 0 ? void 0 : threeTileData.sectionHeadline,
    "data-analytics-variation": threeTileData.variation
  }, threeTileData.cta.label)), __jsx(Carousel, _extends({
    styleType: "threeTileCarousel",
    className: variation,
    classes: {
      carousel: 'nva-3-tile__carousel',
      allTilesContainer: 'nva-3-tile__all-tiles-container'
    }
  }, Settings), threeTileDataList && threeTileDataList.map(function (tileData, index) {
    var _tileData$tileImage$i, _theme$threeTile, _tileData$sys, _tileData$sys2, _tileData$sys3, _tileData$sys4;
    var customCode = null;
    var imgSrc = tileData.tileImage && tileData.tileImage.image && tileData.tileImage.image.file && tileData.tileImage.image.file.url || ((_tileData$tileImage$i = tileData.tileImage.image) === null || _tileData$tileImage$i === void 0 ? void 0 : _tileData$tileImage$i.url);
    var imgAltText = tileData.tileImage && tileData.tileImage.altText;
    var imgTitle = tileData.tileImage && (tileData.tileImage.title || tileData.tileImage.altText);
    var cta = tileData.tileCta;
    var linkStyle = '';
    if (variation === constants.variations.variationB.toLowerCase()) {
      linkStyle = 'secondary-anchor';
    }
    if (theme !== null && theme !== void 0 && (_theme$threeTile = theme.threeTile) !== null && _theme$threeTile !== void 0 && _theme$threeTile.noSecondaryAnchorOnThreeTile && variation === constants.variations.variationB.toLowerCase()) {
      linkStyle = 'primary-anchor';
    }
    if (tileData.tileImage.__typename === 'Mailchimp') {
      customCode = tileData.tileImage;
    }
    var imageTextCardElement = __jsx(ImageTextCard, {
      styleType: "three-tile",
      className: "nva-3-tile__card three-tile",
      ariaLabel: cta === null || cta === void 0 ? void 0 : cta.ariaLabel,
      headingText: tileData.tileHeadline,
      headingType: "h3",
      subParaText: tileData.subHeadline,
      subParaClassName: "nva-3-tile__card-para-subheading heading_four tile-subheading",
      imageSource: imgSrc,
      imageAltText: imgAltText,
      imageTitle: imgTitle,
      linkTitle: tileData.tileHeadline,
      descriptionType: siteConstants.RICH_TEXT,
      descriptionText: tileData.tileText && tileData.tileText.tileText || tileData.tileText && tileData.tileText.json,
      variation: variation,
      key: index,
      ctaSingle: cta,
      imageClassName: "nva-3-tile__card-image tile-image",
      categoryTitleClassName: "nva-3-tile__card-category-title tile-category-title",
      headingClassName: "nva-3-tile__card-heading tile-heading",
      subHeadingClassName: "nva-3-tile__card-subheading tile-subheading",
      paraClassName: "nva-3-tile__card-text tile-para",
      linkClassName: tileAnchorclassName,
      linkStyleType: linkStyle,
      dataAnalytics: {
        type: constants.analytics.analyticsType.tileCTA,
        value: tileData.tileHeadline,
        variation: variation
      },
      srcSetSetting: {
        imageRenditions: imageRenditions
      },
      categoryTitle: tileData.categoryTitle,
      contentfulLivePreviewHeadingText: ContentfulLivePreview.getProps({
        entryId: tileData === null || tileData === void 0 ? void 0 : (_tileData$sys = tileData.sys) === null || _tileData$sys === void 0 ? void 0 : _tileData$sys.id,
        fieldId: "tileHeadline"
      }),
      contentfulLivePreviewSubParaText: ContentfulLivePreview.getProps({
        entryId: tileData === null || tileData === void 0 ? void 0 : (_tileData$sys2 = tileData.sys) === null || _tileData$sys2 === void 0 ? void 0 : _tileData$sys2.id,
        fieldId: "subHeadline"
      }),
      contentfulLivePreviewDescriptionText: ContentfulLivePreview.getProps({
        entryId: tileData === null || tileData === void 0 ? void 0 : (_tileData$sys3 = tileData.sys) === null || _tileData$sys3 === void 0 ? void 0 : _tileData$sys3.id,
        fieldId: "tileText"
      }),
      contentfulLivePreviewCategoryTitle: ContentfulLivePreview.getProps({
        entryId: tileData === null || tileData === void 0 ? void 0 : (_tileData$sys4 = tileData.sys) === null || _tileData$sys4 === void 0 ? void 0 : _tileData$sys4.id,
        fieldId: "categoryTitle"
      }),
      customCode: customCode
    });
    if (tileData !== null && tileData !== void 0 && tileData.tileURL) {
      return __jsx(Anchor, {
        className: "nva-3-tile__anchor-wrapper",
        title: tileData.relatedBlogName,
        to: tileData.tileURL
      }, imageTextCardElement);
    }
    return imageTextCardElement;
  })), (threeTileData === null || threeTileData === void 0 ? void 0 : (_threeTileData$ctaMul = threeTileData.ctaMultipleCollection) === null || _threeTileData$ctaMul === void 0 ? void 0 : _threeTileData$ctaMul.items) && __jsx("div", {
    className: "nva-3-tile__ctas-wrapper"
  }, threeTileData === null || threeTileData === void 0 ? void 0 : (_threeTileData$ctaMul2 = threeTileData.ctaMultipleCollection) === null || _threeTileData$ctaMul2 === void 0 ? void 0 : (_threeTileData$ctaMul3 = _threeTileData$ctaMul2.items) === null || _threeTileData$ctaMul3 === void 0 ? void 0 : _threeTileData$ctaMul3.map(function (item, index) {
    var _item$sys;
    return __jsx(Anchor, {
      key: index,
      "data-entry-id": (_item$sys = item.sys) === null || _item$sys === void 0 ? void 0 : _item$sys.id,
      title: item.label,
      to: item.url,
      ctaBehavior: item.behavior,
      hyperlinkType: item.hyperlinkType,
      className: "nva-3-tile__anchor",
      "aria-label": item.ariaLabel,
      styleType: index === 0 ? 'primary-anchor' : 'secondary-anchor',
      type: item.type,
      ninetailedEvent: item.ninetailedEvent,
      ninetailedTraits: item.ninetailedTraits
    }, item.label);
  })))));
};
ThreeTile.defaultProps = {
  threeTileData: '',
  className: ''
};
export default withTheme(styled(ThreeTile).withConfig({
  componentId: "sc-ckwi5v-1"
})(["", ";"], styles));